/* eslint-disable max-len */
// Opens/closes the clean-coded primary nav's mobile off-canvas panel
// (.b3rg-nav__list, below the xl breakpoint — see _nav-mega-clean.scss).
// A body class (b3rg-nav-mobile-open) is what CSS actually keys off (panel
// slide-in, header dark-bg swap, body scroll lock) — this script only ever
// toggles that class + the toggle button's own data-open attribute, matching
// the data-open-as-source-of-truth approach nav-clean-dropdown.js already
// uses for desktop dropdowns. aria-expanded is kept in sync alongside it
// purely for accessibility — it's no longer what JS/CSS read to decide state.
document.addEventListener( 'DOMContentLoaded', function () {
  const nav = document.querySelector( '.b3rg-nav' );
  if ( !nav ) return;

  const toggle = nav.querySelector( '.b3rg-nav__mobile-toggle' );
  const list = nav.querySelector( '.b3rg-nav__list' );
  if ( !toggle || !list ) return;

  const header = document.querySelector( 'header' );

  // The panel's top edge has to match wherever the header's bottom edge
  // actually is right now — that varies with the admin bar (46px/32px/0,
  // see _header-mobile.scss's .admin-bar header rule), a dismissible
  // .b3rg-notification bar, and initial scroll position (header is
  // position: sticky, not fixed). A single hardcoded `top` value in CSS
  // can't account for all of that, so it's measured here instead.
  function syncPanelTop() {
    if ( header ) {
      list.style.top = header.getBoundingClientRect().bottom + 'px';
    }
  }

  function setOpen( open ) {
    toggle.setAttribute( 'data-open', open ? 'true' : 'false' );
    toggle.setAttribute( 'aria-expanded', open ? 'true' : 'false' );
    // Toggled BEFORE measuring: this class also hides .b3rg-notification
    // (see _nav-mega-clean.scss), which shifts the header's own position —
    // measuring before that layout settles would use the pre-hide height.
    document.body.classList.toggle( 'b3rg-nav-mobile-open', open );
    if ( open ) syncPanelTop();
  }

  toggle.addEventListener( 'click', function () {
    setOpen( toggle.getAttribute( 'data-open' ) !== 'true' );
  } );

  window.addEventListener( 'resize', function () {
    if ( toggle.getAttribute( 'data-open' ) === 'true' ) syncPanelTop();
  } );

  document.addEventListener( 'keydown', function ( event ) {
    if ( event.key === 'Escape' && toggle.getAttribute( 'data-open' ) === 'true' ) {
      setOpen( false );
      toggle.focus();
    }
  } );
} );
